import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

export default function DialogBox({
	title,
	open,
	onCancel,
	cancelLabel = 'Avbryt',
	onClose,
	onCloseLabel = 'Lukk',
	onSave,
	saveLabel = 'Lagre',
	fullWidth = false,
	otherActions,
	children,
	...props
}) {
	return (
		<Dialog
			open={open}
			onClose={onCancel || onClose}
			fullWidth={fullWidth}
			aria-labelledby="dialog-box-title"
			aria-describedby="dialog-box-description"
			{...props}
		>
			<DialogTitle id="dialog-box-title">
				<span>{title}</span>

				{onCancel && (
					<DialogCloseButton
						onClick={onCancel}
						aria-label={cancelLabel}
					/>
				)}

				{onClose && (
					<DialogCloseButton
						onClick={onClose}
						aria-label={onCloseLabel}
					/>
				)}
			</DialogTitle>

			<DialogContent id="dialog-box-description">
				{children}
			</DialogContent>

			<DialogActions>
				{otherActions && otherActions}

				{onCancel && <Button onClick={onCancel}>{cancelLabel}</Button>}

				{onClose && (
					<Button onClick={onClose} variant="contained" autoFocus>
						{onCloseLabel}
					</Button>
				)}

				{onSave && (
					<Button onClick={onSave} variant="contained" autoFocus>
						{saveLabel}
					</Button>
				)}
			</DialogActions>
		</Dialog>
	);
}

export function DialogCloseButton(props) {
	return (
		<IconButton
			aria-label="close"
			sx={{
				position: 'absolute',
				right: 12,
				top: 12,
				color: 'text.secondary',
			}}
			{...props}
		>
			<CloseIcon />
		</IconButton>
	);
}

export {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
};
